var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import { createElement, Component } from 'react';
import { setDisplayName, wrapDisplayName } from 'recompose';

export default (function (methodsArg) {
  return function (Target) {
    var WithLifecycle = function (_Component) {
      _inherits(WithLifecycle, _Component);

      function WithLifecycle(props, context) {
        _classCallCheck(this, WithLifecycle);

        var _this = _possibleConstructorReturn(this, (WithLifecycle.__proto__ || Object.getPrototypeOf(WithLifecycle)).call(this, props, context));

        var methods = typeof methodsArg === 'function' ? methodsArg(props) : methodsArg;

        if (methods) {
          if (methods.onWillMount) {
            _this.componentWillMount = function () {
              methods.onWillMount(_this.props);
            };
          }

          if (methods.onDidMount) {
            _this.componentDidMount = function () {
              methods.onDidMount(_this.props);
            };
          }

          if (methods.onWillReceiveProps) {
            _this.componentWillReceiveProps = function (nextProps) {
              methods.onWillReceiveProps(_this.props, nextProps);
            };
          }

          if (methods.onWillUpdate) {
            _this.componentWillUpdate = function (nextProps) {
              methods.onWillUpdate(_this.props, nextProps);
            };
          }

          if (methods.onDidUpdate) {
            _this.componentDidUpdate = function (prevProps) {
              methods.onDidUpdate(prevProps, _this.props);
            };
          }

          if (methods.onWillUnmount) {
            _this.componentWillUnmount = function () {
              methods.onWillUnmount(_this.props);
            };
          }

          if (methods.onDidCatch) {
            _this.componentDidCatch = function () {
              methods.onDidCatch.apply(methods, arguments);
            };
          }
        }
        return _this;
      }

      _createClass(WithLifecycle, [{
        key: 'render',
        value: function render() {
          return createElement(Target, this.props);
        }
      }]);

      return WithLifecycle;
    }(Component);

    if (process.env.NODE_ENV !== 'production') {
      return setDisplayName(wrapDisplayName(Target, 'withLifecycle'))(WithLifecycle);
    }

    return WithLifecycle;
  };
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@hocs/with-lifecycle/build/browser-esm/index.js
// module id = 37
// module chunks = 0